export default __webpack_public_path__ + "static/media/userSVG.14cdc04c.svg";